var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-whatsappv3-channel-form" } },
    [
      _c("a-form", [
        _c(
          "div",
          { staticClass: "form-wrapper" },
          [
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("channelName"),
                      help: _vm.getErrorMessage("channelName"),
                    },
                  },
                  [
                    _c("a-input", {
                      ref: "channelName",
                      attrs: {
                        placeholder: _vm.$t("whatsappChannel.channelName"),
                        name: "channelName",
                      },
                      model: {
                        value: _vm.form.channelName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "channelName", $$v)
                        },
                        expression: "form.channelName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "mt-1 mb-1" },
                  [
                    _c("a-switch", {
                      attrs: { checked: !!_vm.form.forward.story },
                      on: { click: _vm.toggleChatbot },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "👉 " +
                          _vm._s(
                            _vm.$t("whatsapp_business_api.forwardToChatbot")
                          )
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("whatsapp_business_api.forwarding"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    attrs: {
                      defaultValue: null,
                      notFoundContent: _vm.$t(
                        "whatsapp_business_api.forwardLiveAgents"
                      ),
                      disabled: !_vm.showStories,
                    },
                    on: { change: _vm.handleStoryChange },
                    model: {
                      value: _vm.form.forward.story,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.forward, "story", $$v)
                      },
                      expression: "form.forward.story",
                    },
                  },
                  [
                    _c(
                      "a-select-option",
                      { attrs: { selected: true, value: null } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t("whatsapp_business_api.forwardLiveAgents")
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.stories, function (story) {
                      return _c(
                        "a-select-option",
                        { key: story._id, attrs: { value: story._id } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(story.title) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("whatsapp_business_api.forwardingToDepartment")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    attrs: { defaultValue: null },
                    on: { change: _vm.getSubjectTitle },
                    model: {
                      value: _vm.form.allDepartments,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "allDepartments", $$v)
                      },
                      expression: "form.allDepartments",
                    },
                  },
                  [
                    _c(
                      "a-select-option",
                      { attrs: { selected: true, value: null } },
                      [
                        _vm._v(
                          "👉" +
                            _vm._s(
                              _vm.$t("whatsapp_business_api.selectDepartment")
                            ) +
                            "...\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.subjects, function (department) {
                      return _c(
                        "a-select-option",
                        {
                          key: department._id,
                          attrs: { value: department._id },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getSubjectTitle(department)) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("VisibilityChanger", {
              model: {
                value: _vm.form.visibility,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "visibility", $$v)
                },
                expression: "form.visibility",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("message.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSave },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.save")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }